/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ReportingHierarchy {
    angular.module("meevo.plugins.reportingHierarchy", []);
}